import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class TaxSensitiveAcctService {
  constructor(private http: HttpClient) {}

  loadTaxSensitiveData(
    baseUrl: string,
    rowData: any,
    gridData: any[]
  ): Observable<any> {
    const hasRow = rowData && Object.keys(rowData).length > 0;
    const localAccounts = hasRow
      ? String(rowData.LOCAL_CHART_ACCT_KEY ?? '')
      : _.uniq((gridData || []).map((r: any) => r?.data?.LOCAL_CHART_ACCT_KEY)).join(',');
    const systemAccounts = hasRow
      ? String(rowData.SYS_ACCT_KEY ?? '')
      : _.uniq((gridData || []).map((r: any) => r?.data?.SYS_ACCT_KEY)).join(',');
    const taxYear = hasRow
      ? rowData.TAX_YEAR
      : gridData?.[0]?.data?.TAX_YEAR;

    let params = new HttpParams()
      .set('action_code', '5rvabb')
      .set('tax_year', String(taxYear ?? ''))
      .set('sys_acct', String(localAccounts ?? ''))
      .set('local_accts', String(systemAccounts ?? ''));

    return this.http.get<any>(`${baseUrl}/loadJsonObject`, {
      params,
      withCredentials: true,
    });
  }

  saveTaxSensitiveDetails(
    baseUrl: string,
    details: any[],
    settings: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    return this.postTaxSensitive(
      `${baseUrl}/saveJsonObject?action_code=nbms3a`,
      details,
      settings,
      globalService,
      filterParams,
      'Save_Tax_Sensitive_Details'
    );
  }

  deleteTaxSensitiveDetails(
    baseUrl: string,
    details: any[],
    settings: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    return this.postTaxSensitive(
      `${baseUrl}/saveJsonObject?action_code=nbms3d`,
      details,
      settings,
      globalService,
      filterParams,
      'Delete_Tax_Sensitive_Details'
    );
  }

  private postTaxSensitive(
    url: string,
    details: any[],
    settings: any,
    globalService: any,
    filterParams: any,
    processName: string
  ): Observable<any> {
    let params: any = _.merge({}, globalService || {}, filterParams || {});
    params = _.extend({ jsonObj: JSON.stringify(details || []) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(settings || {}) }, params);
    params.process_name = processName;

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, String(value));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post<any>(url, urlEncoded.toString(), {
      headers,
      withCredentials: true,
    });
  }
}
